/*
 * IMPORTS
 */
import React from 'react' // Npm: react.js library.
import PropTypes from 'prop-types' // Npm: react.js library.
import { toast } from 'react-hot-toast' // Npm: React hot toast.
import { useMutation } from '@apollo/client' // Npm: Apollo client.
import { connect } from 'react-redux' // Npm: React Redux for state management.


/*
 * SIBLINGS
 */
import DeleteCard from 'components/DeleteCard'


/*
 * GRAPHS
 */
import OperatorPrefixDeleteMutation from './__mutation__/index.operatorPrefix.delete.mutation'


/*
 * OBJECTS
 */
const Index = ({ passOn, onClose }) => {
  // Hook assignment.
  const [MutationOperatorPrefixDelete, MutationOperatorPrefixDeleteResponse] = useMutation(OperatorPrefixDeleteMutation)

  // Return Component.
  return (
    <DeleteCard onClose={onClose} disabled={MutationOperatorPrefixDeleteResponse.loading} onConfirm={() =>
      MutationOperatorPrefixDelete({
        'variables': {
          'operatorPrefixId': passOn?.operatorPrefixId
        }
      }).then(i => {
        // Style Guide.
        toast(i?.data?.OperatorPrefixDelete?.message)

        // Report success.
        return onClose?.()
      }).catch(() =>
        // Style Guide.
        toast('Something went wrong please try after some time.'))} isLoading={MutationOperatorPrefixDeleteResponse.loading} />
  )
}


/*
 * PROPTYPES
 */
Index.propTypes = {
  'passOn': PropTypes.object,
  'onClose': PropTypes.func
}


/*
 * REDUX
 */
const _MapStateToProps = __state => ({ 'passOn': __state.PassOn })


/*
 * EXPORT
 */
export default connect(_MapStateToProps)(Index)
